import axios from "axios";
import { UrlParams } from "types/tahseel";

export const postTahseelForm = async (formData: FormData) => {
  const response = await axios.post<UrlParams>("/tenant/integrations/save_tahseel_data", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
      Accept: "application/json",
    },
  });
  return response.data;
};
